import { Role, ActionType } from './constants.js';

export const PERMISSIONS = {
  // Server process
  SERVER_START: [Role.OWNER, Role.ADMIN],
  SERVER_STOP: [Role.OWNER, Role.ADMIN],
  SERVER_RESTART: [Role.OWNER, Role.ADMIN],
  SERVER_FORCE_STOP: [Role.OWNER, Role.ADMIN],
  SERVER_CREATE: [Role.OWNER, Role.ADMIN],
  SERVER_DELETE: [Role.OWNER],

  // Server view
  SERVER_VIEW: [Role.OWNER, Role.ADMIN, Role.DEVELOPER, Role.VIEWER],
  SERVER_METRICS_VIEW: [Role.OWNER, Role.ADMIN, Role.DEVELOPER, Role.VIEWER],

  // Console
  CONSOLE_VIEW: [Role.OWNER, Role.ADMIN, Role.DEVELOPER],
  CONSOLE_COMMAND: [Role.OWNER, Role.ADMIN, Role.DEVELOPER],

  // Files
  FILES_VIEW: [Role.OWNER, Role.ADMIN, Role.DEVELOPER],
  FILES_EDIT: [Role.OWNER, Role.ADMIN, Role.DEVELOPER],
  FILES_DELETE: [Role.OWNER, Role.ADMIN, Role.DEVELOPER],
  FILES_UPLOAD: [Role.OWNER, Role.ADMIN, Role.DEVELOPER],

  // Config & Gamemodes
  CONFIG_EDIT: [Role.OWNER, Role.ADMIN, Role.DEVELOPER],
  GAMEMODE_MANAGE: [Role.OWNER, Role.ADMIN, Role.DEVELOPER],

  // Players
  PLAYERS_VIEW: [Role.OWNER, Role.ADMIN, Role.DEVELOPER, Role.VIEWER],
  PLAYERS_MODERATE: [Role.OWNER, Role.ADMIN],

  // Database
  DATABASE_VIEW: [Role.OWNER, Role.ADMIN, Role.DEVELOPER],
  DATABASE_MANAGE: [Role.OWNER, Role.ADMIN],

  // Backups
  BACKUP_CREATE: [Role.OWNER, Role.ADMIN],
  BACKUP_RESTORE: [Role.OWNER],
  BACKUP_DELETE: [Role.OWNER],

  // System Administration
  USERS_MANAGE: [Role.OWNER],
  AUDIT_VIEW: [Role.OWNER, Role.ADMIN],
  API_KEYS_MANAGE: [Role.OWNER, Role.ADMIN],
} as const;

export type PermissionKey = keyof typeof PERMISSIONS;

export function hasPermission(userRole: Role, permission: PermissionKey): boolean {
  const allowedRoles = PERMISSIONS[permission] as readonly Role[];
  return allowedRoles.includes(userRole);
}

export function roleSatisfies(userRole: Role, minimumRole: Role): boolean {
  const roleHierarchy: Record<Role, number> = {
    [Role.OWNER]: 4,
    [Role.ADMIN]: 3,
    [Role.DEVELOPER]: 2,
    [Role.VIEWER]: 1,
  };

  return roleHierarchy[userRole] >= roleHierarchy[minimumRole];
}
